import { ErrorResponse, FgStatusEnum, JobCompletedEnum, OperationTypeEnum, WorkStationTypeEnum } from '@gtpl/shared-models/common-models';
import { PlantIdRequest, UnitTypeEnum } from '@gtpl/shared-models/masters';
import { AssignBeheadingResponse } from '@gtpl/shared-models/production-management';
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import appSettings from 'apps/services/config';
import { constants } from 'http2';
import { getManager } from 'typeorm';
import { VariantOperationsService } from '../variant-operations/variant-operations.service';
import { WorkStations } from '../workstations/workstations.entity';
import { OperationSequenceRequest } from './dto/operation-sequence.request';
import { ProductionInventoryData } from './dto/production-inventory.dto';
import { ProductionInventory } from './entities/production-inventory.entity';
import { ProductionLog } from './entities/production-log.entity';
import { ProductionLogService } from './production-log.service';
import { ProductionInventoryRepository } from './repositories/production-inventory.repository';
import { ProductionLogRepository } from './repositories/production-log.repository';

@Injectable()
export class BeHeadingService {
    constructor(@InjectRepository(ProductionInventoryRepository)
    private inventoryRepository: ProductionInventoryRepository,
        @InjectRepository(ProductionLogRepository)
        private logRepository: ProductionLogRepository,
        private logService: ProductionLogService,
        private saleOrderService: SaleOrderService,
        private unitCodesService: UnitcodeService,
        private variantOperationService: VariantOperationsService,
    ) { }

    async assignBeHeadingOperation(inputReq: ProductionInventoryData): Promise<AssignBeheadingResponse> {
        const manager = new GenericTransactionManager();
        try {
            // const newmanager = getManager();
            // const query='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+inputReq.plantId;
            //check worksattaion availability
            const workstationData = await this.logRepository.find({where:{workStation:inputReq.workstation,jobStatus:JobCompletedEnum.NO,operationType: OperationTypeEnum.BE_HEADING}})
            console.log(workstationData,'workstationData')
            if(workstationData.length > 0){
                throw new ErrorResponse(9999, 'work station not available');

            }
            const result =await this.unitCodesService.getPlantDetailsById(new PlantIdRequest(inputReq.plantId))
            let columnName
            let productionInventoryData
            if(result.data.plantType==UnitTypeEnum.SUB_PLANT){
                columnName = 'subPlantId'
                productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, subLotNumber: inputReq.lotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: OperationTypeEnum.BE_HEADING,subPlantId:inputReq.plantId} });
              }else{
                columnName = 'plantId'
                  productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: inputReq.lotNumber, subLotNumber: inputReq.lotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: OperationTypeEnum.BE_HEADING, plantId: inputReq.plantId,subPlantId:0 } });
              }
            console.log('jjjjjj',productionInventoryData)
            inputReq.ipBoxes = inputReq.boxes;

            const inventoryInfo = new ProductionInventoryData();
            inventoryInfo.lotNumber = inputReq.lotNumber;
            inventoryInfo.subLotNumber = inputReq.subLotNumber;
            inventoryInfo.saleOrderId = inputReq.saleOrderId;
            inventoryInfo.saleOrderItemId = inputReq.saleOrderItemId;
            inventoryInfo.plantId = inputReq.plantId;
            inventoryInfo.subPlantId = inputReq.subPlantId;   
            inventoryInfo.operation = inputReq.operation;
            inventoryInfo.nextOperation = OperationTypeEnum.GRADING;

            const prodLogPrevOp = await this.logService.getPrevOperations(inputReq.lotNumber, inputReq.workstation, inputReq.plantId, OperationTypeEnum.BE_HEADING, inventoryInfo,null,columnName);
            let prodInvResponse;
            inputReq.subLotNumber = inputReq.lotNumber
            inputReq.operation = OperationTypeEnum.BE_HEADING
            inputReq.wipQuantity = inputReq.physicalQuantity;
            //calculate output boxes 
            let outPutBoxes = Math.ceil(inputReq.boxes * (0.7));
            inputReq.opBoxes = outPutBoxes;
            //calculate output grade 
            let outPutGrade = Math.ceil(inputReq.inputGrade * (0.7));

            const getHlPercentage = await this.saleOrderService.getHlPercentage({ saleOrderItemId: inputReq.saleOrderItemId });
            await manager.startTransaction();
            let productioninvId
            if (productionInventoryData) {
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryQuantity(inputReq,columnName);
                productioninvId = productionInventoryData.productionInventoryId
            } else {
                const prodInv = new ProductionInventory();
                prodInv.lotNumber = inputReq.lotNumber;
                prodInv.createdUser = inputReq.createdUser;
                prodInv.subLotNumber = inputReq.lotNumber;
                prodInv.saleOrderId = inputReq.saleOrderId;
                prodInv.saleOrderItemId = inputReq.saleOrderItemId;
                prodInv.operation = OperationTypeEnum.BE_HEADING;
                // prodInv.nextOperation = OperationTypeEnum.GRADING;
                prodInv.wipQuantity = inputReq.physicalQuantity;
                prodInv.inputGrade = inputReq.inputGrade;

                prodInv.outputGrade = inputReq.inputGrade;


                prodInv.boxes = inputReq.boxes;
                if(result.data.plantType == UnitTypeEnum.PLANT){
                    prodInv.subPlantId = inputReq.subPlantId;
                    prodInv.plantId = inputReq.plantId;
                }
                if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                    prodInv.subPlantId = inputReq.plantId;
                    prodInv.plantId = inputReq.mainPlantId;

                }
                // prodInv.plantId = inputReq.plantId;
                if (inputReq.workStationType == WorkStationTypeEnum.EXTERNAL) {
                    prodInv.intransitQuantity = inputReq.physicalQuantity;
                }
                
                // if (inputReq.subPlantId) {
                //     prodInv.subPlantId = inputReq.subPlantId;
                // }
                prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
                productioninvId = prodInvResponse.productionInventoryId
            }

            if (prodInvResponse) {
                // if(prodLogUpdatePrevOp){
                const percentage = getHlPercentage.hlPercentage
                let gmsMinWeight = 454 / getHlPercentage.minGrade;
                let gmsMaxWeight = 454 / getHlPercentage.minGrade;
                //outputproduct count and quantity calculation
                let outputMinWeight
                let outputMaxWeight
                if (percentage != 0) {
                    outputMinWeight = gmsMinWeight / ((percentage / 100));
                    outputMaxWeight = gmsMaxWeight / ((percentage / 100));

                } else {
                    outputMinWeight = 0
                    outputMaxWeight = 0
                }

                const productMinCount = 1000 / outputMinWeight;
                const productMaxCount = 1000 / outputMaxWeight;
                const avgCount = (productMinCount + productMaxCount) / 2;
                const count = Math.ceil(avgCount / 5) * 5;
                const qty = Math.round(inputReq.physicalQuantity * (percentage / 100));



                const productionLogObj = new ProductionLog();
                productionLogObj.lotNumber = inputReq.lotNumber;
                productionLogObj.subLotNumber = inputReq.lotNumber;
                productionLogObj.saleOrderId = inputReq.saleOrderId;
                productionLogObj.saleOrderItemId = inputReq.saleOrderItemId;
                productionLogObj.operationType = inputReq.operation;
                // job number generation 
                let today = new Date();
                let CurrentYear = today.getFullYear();
                let CurrentMonth = today.getMonth();
                let fromDate = 0;
                let toDate = 0;
                let totalRecords = await (await this.logRepository.find({ where: { operationType: OperationTypeEnum.BE_HEADING } })).length;


                if ((CurrentMonth+1) < 4) {
                    fromDate = (CurrentYear-1);
                    toDate = (CurrentYear);
                } else {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                }

                totalRecords = totalRecords + 1;

                var refNo = totalRecords + "";
                while (refNo.length < 4) refNo = "0" + refNo;

                const deHeadJobNo = "DeHead/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;



                if (inputReq.workStationType == WorkStationTypeEnum.EXTERNAL) {
                    let totalExternalRecords = await (await this.logRepository.find({ where: { operationType: OperationTypeEnum.BE_HEADING, workStationType: WorkStationTypeEnum.EXTERNAL } })).length;

                    totalExternalRecords = totalExternalRecords + 1;

                    var refNo = totalExternalRecords + "";
                    while (refNo.length < 4) refNo = "0" + refNo;

                    const deHeadDCJobNo = "DeHead/DC/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

                    productionLogObj.dcNumber = deHeadDCJobNo;//need to write auto generate logic

                }

                productionLogObj.jobNumber = deHeadJobNo;//need to write auto generate logic
                //plant and subplant wise data saving
                if(result.data.plantType == UnitTypeEnum.PLANT){
                    productionLogObj.subPlantId = inputReq.subPlantId;
                    productionLogObj.plantId = inputReq.plantId;
                }
                if(result.data.plantType == UnitTypeEnum.SUB_PLANT){
                    productionLogObj.subPlantId = inputReq.plantId;
                    productionLogObj.plantId = inputReq.mainPlantId;

                }
                // if (inputReq.subPlantId) {
                    // productionLogObj.subPlantId = inputReq.subPlantId;
                // } else {
                    productionLogObj.workstation = new WorkStations();
                    productionLogObj.workstation.workstationId = inputReq.workstation;
                // }

                productionLogObj.workStationType = inputReq.workStationType;
                productionLogObj.jobStatus = JobCompletedEnum.NO;
                productionLogObj.inputGrade = inputReq.inputGrade;
                productionLogObj.inputQuantity = inputReq.physicalQuantity;
                productionLogObj.plannedOutputQuantity = inputReq.physicalQuantity;
                productionLogObj.actualOutputQuantity = qty;
                productionLogObj.wastageQuantity = (inputReq.physicalQuantity - qty);
                productionLogObj.inputBoxes = inputReq.boxes;
                productionLogObj.outputBoxes = outPutBoxes;
                productionLogObj.assignedTime = inputReq.assignedTime;
                productionLogObj.assignedUser = inputReq.createdUser;//need to get assigned user
                productionLogObj.shift = inputReq.shift;
                productionLogObj.createdUser = inputReq.createdUser;
                productionLogObj.prodInvId = productioninvId;
                const saveProdLog = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);


                if (saveProdLog) {
                    // update previous Operation(RM Inventory) Issued Quantity
                    const previousOpQty = await manager.getCustomRepository(ProductionInventoryRepository).updateIssuedQty(inputReq.plantId, OperationTypeEnum.BE_HEADING, inputReq.lotNumber, inputReq.subLotNumber, inputReq.saleOrderId, inputReq.saleOrderItemId, inputReq.physicalQuantity,columnName)
                    let isCompleted = true;
                    if (prodLogPrevOp) {
                        //removed automatic previous job completion for same workstation as op boxes edit given in deheading WIP screen.If automatically close no data found in the WIP screen
                        // const previousOpUpdate = await this.logService.updateBeheadingJobCompleted(prodLogPrevOp, manager,columnName)
                        
                        // if (!previousOpUpdate.status) {
                        //     isCompleted = false;
                        // }
                    }
                 
                    if (previousOpQty && isCompleted) {
                        manager.completeTransaction();
                    } else {
                        await manager.releaseTransaction();
                        throw new ErrorResponse(9999, 'Failed to Update Previous Job, Job Not Assigned Please contact admin');
                    }
                    return new AssignBeheadingResponse(true, 5555, 'Work station allocated and material assigned to beheading', true)
                } else {
                    await manager.releaseTransaction();
                    throw new ErrorResponse(9999, 'Failed to Save Production, Please contact admin');
                    //return new AssignBeheadingResponse(false, 9999, 'some thing went wrong', false)
                }
                // }else{
                //     throw new ErrorResponse(9999, 'Failed to update previous operation');
                // }

            } else {
                await manager.releaseTransaction();
                throw new ErrorResponse(9999, 'Failed to Save Inventory, Job not assigned');
            }

        } catch (error) {
            await manager.releaseTransaction();
            return error;
        }
    }
}
